import React from 'react'
import { DynamicIcon, type IconName } from 'lucide-react/dynamic'

export interface IconRendererProps {
  name: string
  size?: number
}

// Frontend-safe icon renderer. Kept in its own module (not re-exported from
// the index) so frontend code can import this without pulling in the admin
// IconPicker's @payloadcms/ui dependency tree (which would drag in
// react-datepicker, ~580 KiB per route).
export const IconRenderer: React.FC<IconRendererProps> = React.memo(({ name, size = 20 }) => {
  return <DynamicIcon name={name as IconName} size={size} />
})

IconRenderer.displayName = 'IconRenderer'
